module.exports = __webpack_public_path__ + "media/images/cplook/arrows-adc99c90c60d75c18326b2b7f08cbdda.png";